import { type ReactElement, type ReactNode, useState, useEffect, Children } from "react"
import { useForm, SubmitHandler, Controller } from "react-hook-form";
import Modal from "src/components/Modal";
import Button from "src/components/Button";

export interface DeleteModalProps {
        title: string,
        isOpen: boolean,
        onClose: () => void,
        delete: (value: boolean) => void,
        children?: ReactNode
}

export default function DeleteModal(props: DeleteModalProps): ReactElement {

        const isDelete = () => {
                props.delete(true);
        }


        return <>
                <Modal isOpen={props.isOpen} modalSize="lg" onClose={props.onClose}>
                        <h2 className="text-lg font-bold text-center">
                                {props.title}
                        </h2>
                        <div className="flex justify-center p-8 items-center">
                                {props.children}
                        </div>
                        <div className="flex gap-16 justify-around">
                                <Button className="" size="lg" type="button" buttonStyle="delete" handleClick={props.onClose}>Cancel</Button>
                                <Button className="" size="lg" type="button" buttonStyle="primary" handleClick={isDelete}>Ok</Button>
                        </div>
                </Modal>
        </>
}
